<template>
  <section class="col-12 col-xl-12 col-md-12 box-col-12">
    <div class="card item-work-wraper">
      <div class="card-header">{{ $t('penglaman_kerja') }}</div>

      <div class="card-body">
        <ItemWork v-for="(item,idx) in works" :key="idx" :item="item"></ItemWork>
        <!-- <ItemPendidikan></ItemPendidikan>
        <ItemPendidikan></ItemPendidikan>
        <ItemPendidikan></ItemPendidikan>
        <ItemPendidikan></ItemPendidikan> -->
      </div>

      <div class="card-action">
        <button v-b-modal.work class="btn btn-block btn-action"><i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>Add {{ $t('penglaman_kerja') }}</button>
      </div>
    </div>

    <!-- Vertically centered Modal Component -->
    <b-modal
      id="work"
      size="lg"
      width="100%"
      centered
      :title="`Add ${$t('penglaman_kerja')}`"
      ok-title="Save"
      cancel-title="Cancel"
      class="theme-modal"
      @ok="handleSubmit"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('job_title') }}</h6>
            <input
              class="form-control"
              v-model="form.title"
              :placeholder="$t('job_title')"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('nama_perusahaan') }}</h6>
            <input
              class="form-control"
              v-model="form.nama_perusahaan"
              :placeholder="$t('nama_perusahaan')"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('provinsi') }}</h6>
            <input
              class="form-control"
              v-model="form.lokasi"
              :placeholder="$t('provinsi')"
            />
            <!-- <multiselect
              v-model="form.lokasi"
              :options="dataSource.provinces"
              :searchable="true"
              label="name"
              :close-on-select="true"
              :show-labels="true"
              :placeholder="$t('lokasi')"
            ></multiselect> -->
          </div>
        </div>

         <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{$t('bidang_usaha')}}</h6>
            <input
              class="form-control"
              v-model="form.bidang_usaha"
              :placeholder="$t('bidang_usaha')"
            />
          </div>
        </div>

         <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('status_kepegawaian') }}</h6>
            <multiselect
              v-model="form.status_pegawai"
              :options="dataSource.status"
              :searchable="true"
              label="name"
              :close-on-select="true"
              :show-labels="true"
              :placeholder="$t('status_kepegawaian')"
            ></multiselect>
          </div>
        </div>


        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('tanggal_mulai') }}</h6>
            <datepicker input-class="datepicker-here form-control digits" v-model="dateMulai" :format="'dd/MM/yyyy'" ></datepicker>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('tanggal_selesai') }}</h6>
            <datepicker input-class="datepicker-here form-control digits" v-model="dateEnd" :format="'dd/MM/yyyy'" ></datepicker>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{$t('keterampilan_terkait_pekerjaan')  }}</h6>
            <b-form-tags v-model="form.keterampilan" :placeholder="$t('keterampilan_terkait_pekerjaan')"></b-form-tags>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-0">
            <h6 class="form-label">{{ $t('deskripsi_pekerjaan') }}</h6>
            <textarea
              class="form-control"
              rows="4"
              v-model="form.deskripsi"
              :placeholder="$t('deskripsi_pekerjaan')"
            ></textarea>
          </div>
        </div>

      </div>
    </b-modal>
  </section>
</template>

<script>
  import ItemWork from './item/ItemWork.vue';
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vuejs-datepicker';
  import { getDataProvinces } from "../../_services/data.service";
  import { formatDate } from '../../_helpers';
  import { submitDataWork,getDataWork } from "../../_services/profile.service";

  export default {
    components: {
      ItemWork,
      Multiselect,
      Datepicker
    },
    data() {
      return {
        dataSource :{
          status: [
            {
              name: 'Karyawan Kontrak',
              value: 'Karyawan Kontrak'
            },
            {
              name: 'Karwayan Tetap',
              value: 'Karyawan Kontrak'
            },
            {
              name: 'Kesepakatan Kerja Waktu Tertentu',
              value: 'Kesepakatan Kerja Waktu Tertentu'
            },
            {
              name: 'Magang',
              value: 'Magang'
            },
            {
              name: 'Mitra',
              value: 'Mitra'
            },
            {
              name: 'Probation',
              value: 'Probation'
            },
            {
              name: 'PRJB',
              value: 'PRJB'
            },
            {
              name: 'Traine',
              value: 'Traine'
            },
            {
              name: 'Volunteer',
              value: 'Volunteer'
            },
            {
              name: 'Lainya',
              value: 'Lainya'
            },
          ],
          provinces: ''
        },
        form : {
          id_user : this.$route.query.id_user,
          title: '',
          nama_perusahaan : '',
          lokasi : '',
          bidang_usaha : '',
          status_pegawai : '',
          tanggal_mulai : '',
          tanggal_selesai : '',
          keterampilan : [],
          deskripsi : ''
        },
        works: []
      };
    },
    computed:{
      dateMulai : {
        get(){
          return this.form.tanggal_mulai;
        },
        async set(val){
          this.form.tanggal_mulai = await formatDate(val);
        },
      },
      dateEnd : {
        get(){
          return this.form.tanggal_selesai;
        },
        async set(val){
          this.form.tanggal_selesai = await formatDate(val);
        },
      }
    },
    mounted(){
      this.fetchDataProvinces();
      this.fetchDataWork();
      let lang = localStorage.getItem('currentLanguage') ?  localStorage.getItem('currentLanguage') : process.env.VUE_APP_LANG;
      if (lang == 'en') {
        this.dataSource = {
          status: [
            {
              name: 'Contract employees',
              value: 'Karyawan Kontrak'
            },
            {
              name: 'Permanent employees',
              value: 'Karyawan Kontrak'
            },
            {
              name: 'Fixed Time Work Agreement',
              value: 'Kesepakatan Kerja Waktu Tertentu'
            },
            {
              name: 'Internship',
              value: 'Magang'
            },
            {
              name: 'Partner',
              value: 'Mitra'
            },
            {
              name: 'Probation',
              value: 'Probation'
            },
            {
              name: 'PRJB',
              value: 'PRJB'
            },
            {
              name: 'Traine',
              value: 'Traine'
            },
            {
              name: 'Volunteer',
              value: 'Volunteer'
            },
            {
              name: 'Other',
              value: 'Lainya'
            },
          ],
        };
      }
    },
    methods : {
      async fetchDataProvinces(){
        await getDataProvinces().then(res => {
          this.dataSource.provinces = res;
        });
      },
      async fetchDataWork(){
        this.works = await getDataWork(this.$route.query.id_user);
      },
      async handleSubmit(){
        await submitDataWork(this.form);
        this.fetchDataWork();
      }
    }
  };
</script>

<style lang="scss">
.item-work-wraper {
  padding: 0;
  .card-header {
    padding: 18px 25px !important;
    font-size: 1.1rem;
    font-weight: 500;
  }
  .item {
    flex-direction: column;
    h3 {
      font-size: 0.9rem;
      font-weight: 500;
    }
    h5 {
      font-size: 0.9rem;
      font-weight: 400;
    }
  }
  .card-body {
    padding: 18px 25px !important;
    gap: 1rem;

    max-height: 530px;
    height: 530px;
    overflow: auto;
    flex-direction: column;
  }

  .item-personal {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-address {
    -ms-flex: 0 0 50%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-minat {
    -ms-flex: 0 0 30%;
    -webkit-box-flex: 0;
    flex: 0 0 30%;
    max-width: 30%;
    padding: 18px 25px;
    display: flex;
    flex-direction: column;

    .item-hobie {
      flex: 1;
      h3 {
        font-size: 0.9rem;
        font-weight: 500;
      }

      .list-item {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        .rounded {
          padding: 0.2rem 1rem;
          background: var(--theme-deafult);
          color: var(--theme-font);
          font-size: 0.7rem;
          border-radius: 1rem !important;
        }
      }
    }
  }

  .btn-action{
    border-top: 1px solid #E9ECEF;
    font-weight: 600;
    padding-top: .7rem;
    padding-bottom: .7rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    color: #1d1e26;
    .fa{
      font-size: 1rem;
    }
  }

  .card-body {
    display: flex;
    .d-flex {
      width: 100%;
    }
  }
}
</style>
